module.exports = __webpack_public_path__ + "static/media/payouts.8637fda7.png";